<template>
  <div>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6"> توضیحات (اختیاری): </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input
            accept="image/*"
            label="پیوست مدرک (اختیاری)"
            v-model="image"
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="primary white--text"
          class="register"
          rounded
          @click="applyRequest"
        >
          ثبت
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      comment: "",
      image: {},
    };
  },
  props: ["schoolID"],
  methods: {
    /**
     * check user input and  then send khorooj request
     */
    applyRequest() {
     
      this.$emit("clicked", this.image, this.schoolID, this.comment);
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}
.form {
  top: 100px;
}




.register {
  width: 300px !important;
  margin: 20px auto;
}
.v-text-field__details {
  display: none;
}

@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
